import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CognitoServiceService } from '../../services/cognito-service.service';
import { FormDefinitionsService } from '../../services/forms/form-definitions.service';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  vua: any;
  forgotPwdForm: any;

  constructor(
    private router: Router,
    private cognito: CognitoServiceService,
    private formDefinitionsService: FormDefinitionsService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.forgotPwdForm = this.formDefinitionsService.forgotPwdForm
  }

  forgotPassword(event) {
    let form = event.formData;
    this.vua = form.value.vua;

    this.cognito.forgotPassword(form.controls.vua.value, (status, error?)=> {
      if(status) {
        form.reset();
        this.router.navigate(['/confirm-password'], { queryParams: { vua: this.vua } });
      } else {
        this.showGlobalPopup(error.message || JSON.stringify(error));
      }
    });
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalPopup(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body
    }
    
    this.commonService.showGlobalMessage(popuptext);
  }

}
